import {
  imageCaseStudyType,
  TwoImagesHeadlineGrid,
  TwoImagesHeadlineGridProps,
} from '@rimactechnology/rimac-ui-lib';

import { TwoImagesGridFragment } from '@/api';
import getCdlPublicId from '@/hooks/useCdlPublicId';

interface TwoImagesGridProps {
  twoImagesGrid?: TwoImagesGridFragment | null;
  titleMaxWidth?: number;
  descriptionMaxWidth?: number;
}

export default function TwoImagesGrid({
  twoImagesGrid,
  titleMaxWidth,
  descriptionMaxWidth,
}: TwoImagesGridProps) {
  const twoImagesGridProps: TwoImagesHeadlineGridProps = {
    title: twoImagesGrid?.title || '',
    anchor: twoImagesGrid?.anchor || undefined,
    titleMaxWidth,
    descriptionMaxWidth,
    cards: (twoImagesGrid?.imagesGridItem || []).map((imagesGridItem) => ({
      title: imagesGridItem?.title || '',
      text: imagesGridItem?.description || '',
      tagName: imagesGridItem?.tag || '',
      tagType: (imagesGridItem?.tagColor || 'default') as imageCaseStudyType,
      image: {
        imgSrc: getCdlPublicId(
          imagesGridItem?.img_desktop.data?.attributes?.url || '',
        ),
        imgSrcMobile: getCdlPublicId(
          imagesGridItem?.img_mobile?.data?.attributes?.url || undefined,
        ),
        alt: imagesGridItem?.alt || 'certification',
        blurHash:
          imagesGridItem?.img_desktop.data?.attributes?.blurhash || '12312312',
      },
    })),
  };

  return <TwoImagesHeadlineGrid {...twoImagesGridProps} />;
}
